import { useCallback, useMemo, useRef } from 'react';
import { reactHookForm } from '@yola/ws-ui';
import getFieldNamesByTabId from '../helpers/get-field-names-by-tab-id';
import constants from '../constants';

const { useFormState } = reactHookForm;
const { fieldNames } = constants;

const useScrollToError = ({ control }) => {
  const fieldNameRef = useRef(null);
  const fieldPathRef = useRef(null);
  const fieldPasswordRef = useRef(null);
  const fieldTitleRef = useRef(null);
  const fieldDescriptionRef = useRef(null);

  const fieldRefs = useMemo(
    () => ({
      [fieldNames.NAME]: fieldNameRef,
      [fieldNames.PATH]: fieldPathRef,
      [fieldNames.PASSWORD]: fieldPasswordRef,
      [fieldNames.TITLE]: fieldTitleRef,
      [fieldNames.DESCRIPTION]: fieldDescriptionRef,
    }),
    [fieldNameRef, fieldPathRef, fieldPasswordRef]
  );

  const { errors } = useFormState({
    control,
    name: Object.keys(fieldRefs),
  });

  const scrollToError = useCallback(
    (tabId) => {
      const fieldNamesWithErrors = Object.keys(errors);

      if (!fieldNamesWithErrors.length) {
        return;
      }

      const fieldNameWithError = getFieldNamesByTabId(tabId).find((fieldName) =>
        fieldNamesWithErrors.includes(fieldName)
      );

      if (!fieldNameWithError) {
        return;
      }

      const fieldRef = fieldRefs[fieldNameWithError];

      if (!fieldRef.current) {
        return;
      }

      fieldRef.current.scrollIntoView({ behavior: 'smooth' });
    },
    [errors, fieldRefs]
  );

  return {
    scrollToError,
    fieldRefs,
  };
};

export default useScrollToError;
